import { v7 as uuidv7 } from "uuid";
import { z } from "zod";

export const flagColumnSchema = z.object({
  id: z.string().uuid(),
  quantityId: z.string().uuid(),
  name: z.string(),
  sortOrder: z.number(),
  unit: z.string().nullish(),
});

export const newFlagColumnInputSchema = flagColumnSchema.omit({
  id: true,
});

export const editFlagColumnInputSchema = flagColumnSchema.pick({
  name: true,
});

export type FlagColumn = z.infer<typeof flagColumnSchema>;
export type FlagColumnInput = z.input<typeof flagColumnSchema>;
export type NewFlagColumnInput = z.input<typeof newFlagColumnInputSchema>;

export const createFlagColumn = (input: NewFlagColumnInput): FlagColumn => {
  return newFlagColumn({
    ...input,
    id: uuidv7(),
  });
};

export const newFlagColumn = (input: FlagColumnInput): FlagColumn => flagColumnSchema.parse(input);
